// Copied from old theme with some modifications to support the new product selector on the new theme
class customProductSelector {
  constructor(selectorElementId) {
    this.childProductJSON = {};
    this.productId;
    this.selectorElementId = selectorElementId;
    this.parentElementSelectorQuery;
    this.radioButtonsWrapElem = document.getElementById(this.selectorElementId);
    this.radioButtonsOptionsWrapElem = document
      .getElementById(this.selectorElementId)
      .querySelector(".options_container");
    this.templateSuffix = "";
    this.productHandleTemplate = "/products/{handle}";
    this.productDetailsHidden = true;
    this.selectorGroupValueTextClass = "selector_group__value_text_";
    this.primaryOptionClass = "custom_select__primary_input";
    this.elementUpdateContentMap;
    this.autoSelectOnLoad = true;
    this.isLoading = false;
    this.dependencyRules = null;
  }

  init() {
    // Show loading immediately when init starts
    this.showLoading();

    if (this.childProductJSON.length == 0) {
      this.hideLoading();
      return;
    }

    if (!this.autoSelectOnLoad) {
      document.getElementById(
        this.selectorElementId + "__alert"
      ).style.display = "block";
    }

    let selectorOptions = {};
    for (let options of this.childProductJSON) {
      for (let option in options) {
        if (option == "id" || option == "handle") {
          continue;
        }
        selectorOptions[option] = selectorOptions[option] || [];
        if (
          !selectorOptions[option].some((row) =>
            row["full_value"].includes(options[option])
          )
        ) {
          let optionValues = {
            full_value: options[option],
            short_value: "",
            long_value: "",
          };

          var regExp = /\[([^)]+)\]/;
          var values = regExp.exec(options[option]);

          optionValues.short_value = values ? values[1] : "";
          optionValues.long_value = options[option].replace(
            / *\[[^)]*\] */g,
            ""
          );
          selectorOptions[option].push(optionValues);
        }
      }
    }

    const variantsSortOrder = this.variantsSortOrder;
    if (variantsSortOrder && variantsSortOrder.length > 0) {
      let tempSelectorOptions = {};
      for (let option of variantsSortOrder) {
        if (selectorOptions[option]) {
          tempSelectorOptions[option] = selectorOptions[option];
        }
      }
      selectorOptions = tempSelectorOptions;
    }

    for (let selectors in selectorOptions) {
      const sortOrder = this.optionsSortOrder?.[selectors];

      if (sortOrder && Array.isArray(selectorOptions[selectors])) {
        const getToken = (str) => {
          const m = String(str).match(/^\s*(\[[^\]]+\])/);
          return m ? m[1] : null;
        };

        const sortTokens = sortOrder.map((s) => getToken(s)).filter(Boolean);
        const orderIndex = new Map(sortTokens.map((t, i) => [t, i]));

        const tokenRank = (t) => {
          const inner = t ? t.slice(1, -1) : "";
          const m = inner.match(/^([A-Za-z]+)(\d+)$/);
          if (m) {
            return { prefix: m[1], num: Number(m[2]), raw: inner };
          }
          return { prefix: inner, num: Number.POSITIVE_INFINITY, raw: inner };
        };

        selectorOptions[selectors].sort((a, b) => {
          const aTok = getToken(a.full_value);
          const bTok = getToken(b.full_value);

          const aFixed = orderIndex.has(aTok) ? orderIndex.get(aTok) : Infinity;
          const bFixed = orderIndex.has(bTok) ? orderIndex.get(bTok) : Infinity;

          if (aFixed !== bFixed) return aFixed - bFixed;

          const ar = tokenRank(aTok);
          const br = tokenRank(bTok);

          if (ar.prefix !== br.prefix) {
            return ar.prefix.localeCompare(br.prefix, undefined, {
              numeric: true,
              sensitivity: "base",
            });
          }
          if (ar.num !== br.num) return ar.num - br.num;

          return String(a.full_value).localeCompare(
            String(b.full_value),
            undefined,
            { numeric: true, sensitivity: "base" }
          );
        });
      }

      this.createRadio(selectors, selectorOptions[selectors]);
    }

    const beltInput = this.radioButtonsWrapElem
      .closest("form")
      ?.querySelector("beltdriven-toggle input[type='checkbox']");
    if (beltInput) {
      beltInput.addEventListener("change", () => {
        this.updateBeltDrivenMotorUi();
        if (!beltInput.checked) {
          const checked = this.radioButtonsWrapElem.querySelector(
            'input[type="radio"]:checked'
          );
          if (checked) {
            this.applyDependencyRules(checked.name, checked.value);
          }
        }
      });
    }

    // Hide loading after all radios are created but before auto-selection
    this.hideLoading();

    if (this.autoSelectOnLoad) {
      const primaryInputs = this.radioButtonsWrapElem.querySelectorAll(
        ".custom_select__primary_input"
      );
      for (let input of primaryInputs) {
        input.click();
      }
    }

    this.updateBeltDrivenMotorUi();
  }

  createRadio(name, options) {
    const radioContainer = document.createElement("div");
    const radioContainerTitle = document.createElement("h3");
    const radioOptionValueText = document.createElement("span");

    radioOptionValueText.classList.add("selector_group__value_text");
    radioOptionValueText.classList.add(
      this.selectorGroupValueTextClass + this.lowerNoSpaces(name)
    );

    radioContainer.id =
      this.productId + "_" + this.lowerNoSpaces(name) + "_selector_group";
    radioContainer.setAttribute("data-name", name);
    radioContainer.classList.add("selector_group");

    let firstOption = true;
    for (let key in options) {
      let elemId =
        this.productId +
        "_" +
        "option_" +
        this.lowerNoSpaces(name) +
        "_" +
        this.lowerNoSpaces(options[key]["long_value"]);
      let container = document.createElement("div");
      let shortValue = options[key]["short_value"];
      container.classList.add("custom_select__container");
      let label = document.createElement("label");
      label.dataset.title = options[key]["long_value"];
      label.htmlFor = elemId;

      if (shortValue.startsWith("#")) {
        let swatchHolder = document.createElement("span");
        swatchHolder.classList.add("custom_select__swatch");
        swatchHolder.style.background = shortValue;
        label.appendChild(swatchHolder);
      } else {
        label.innerText = shortValue.length
          ? shortValue
          : options[key]["long_value"];
      }

      label.addEventListener("mouseover", (event) => {
        let span = event.target.querySelector("span");

        if (event.target.tagName !== "LABEL") return;
        let originalText = radioOptionValueText.innerText;
        let text = event.target.dataset.title;
        radioOptionValueText.innerText = text;

        if (span) {
          span.addEventListener("mouseover", (event) => {
            radioOptionValueText.innerText = text;
          });
        }

        label.addEventListener("mouseout", (event) => {
          if (label.previousElementSibling.checked) {
            return;
          } else {
            radioOptionValueText.innerText = originalText;
          }
        });
      });

      let input = document.createElement("input");
      input.name = name;
      input.value = options[key]["full_value"];
      input.id = elemId;
      input.dataset.optionTitleText = options[key]["long_value"];
      input.title = options[key]["long_value"];
      input.type = "radio";
      input.required = true;

      input.addEventListener("change", this.radioListener.bind(this));
      if (firstOption) {
        input.classList.add("custom_select__primary_input");
        firstOption = false;
      }
      let tooltip = document.createElement("span");
      tooltip.classList.add("custom_select__tooltip");
      tooltip.innerText = options[key]["long_value"];
      container.appendChild(input);
      container.appendChild(label);
      if (shortValue) {
        container.appendChild(tooltip);
      }
      radioContainer.appendChild(container);
    }
    this.radioButtonsOptionsWrapElem.appendChild(radioContainer);
    radioContainerTitle.innerText = name;
    radioContainer.appendChild(radioContainerTitle);
    radioContainerTitle.appendChild(radioOptionValueText);
  }

  isMotorNotIncludedValue(fullValue) {
    return /^\s*\[N\]/.test(String(fullValue));
  }

  getMotorSelectorGroup() {
    return this.radioButtonsOptionsWrapElem?.querySelector(
      '.selector_group[data-name="Motor"]'
    );
  }

  /**
   * When Belt driven is on (Ocean Master), only Motor option [N] is allowed and is auto-selected.
   */
  updateBeltDrivenMotorUi() {
    const form = this.radioButtonsWrapElem?.closest("form");
    const beltInput = form?.querySelector(
      "beltdriven-toggle input[type='checkbox']"
    );
    const motorGroup = this.getMotorSelectorGroup();
    if (!motorGroup) return;

    const clearBeltMotorLock = () => {
      motorGroup
        .querySelectorAll('[data-belt-motor-disabled="true"]')
        .forEach((container) => {
          container.removeAttribute("data-belt-motor-disabled");
          container.style.opacity = "";
          container.style.pointerEvents = "";
          const input = container.querySelector('input[type="radio"]');
          if (input) input.disabled = false;
          const label = container.querySelector("label");
          if (label) label.classList.remove("no-motor");
        });
    };

    if (!beltInput?.checked) {
      clearBeltMotorLock();
      return;
    }

    let nInput = null;
    motorGroup.querySelectorAll('input[type="radio"]').forEach((input) => {
      if (this.isMotorNotIncludedValue(input.value)) nInput = input;
    });
    if (!nInput) {
      clearBeltMotorLock();
      return;
    }

    const valueTextClass =
      this.selectorGroupValueTextClass + this.lowerNoSpaces("Motor");
    const valueText = this.radioButtonsWrapElem.querySelector(
      "." + valueTextClass
    );

    motorGroup.querySelectorAll(".custom_select__container").forEach(
      (container) => {
        const input = container.querySelector('input[type="radio"]');
        if (!input) return;
        const label = container.querySelector("label");

        if (this.isMotorNotIncludedValue(input.value)) {
          container.removeAttribute("data-belt-motor-disabled");
          container.style.opacity = "";
          container.style.pointerEvents = "";
          input.disabled = false;
          if (label) label.classList.remove("no-motor");
        } else {
          container.setAttribute("data-belt-motor-disabled", "true");
          container.style.opacity = "0.6";
          container.style.pointerEvents = "none";
          input.disabled = true;
          if (label) label.classList.add("no-motor");

          if (input.checked) {
            input.checked = false;
            if (valueText) {
              valueText.innerText = "";
              valueText.classList.remove("selector_group__value_text_filled");
            }
          }
        }
      }
    );

    const checked = motorGroup.querySelector('input[type="radio"]:checked');
    if (!checked || !this.isMotorNotIncludedValue(checked.value)) {
      requestAnimationFrame(() => nInput.click());
    }
  }

  applyDependencyRules(changedOptionName, changedOptionValue) {
    if (!this.dependencyRules || !Array.isArray(this.dependencyRules)) return;

    // Collect all currently selected values
    const selectedValues = {};
    const inputs = this.radioButtonsWrapElem.querySelectorAll('input[type="radio"]:checked');
    inputs.forEach((input) => {
      selectedValues[input.name] = input.value;
    });
    // Override with the currently changing input
    selectedValues[changedOptionName] = changedOptionValue;

    // Reset all containers to enabled state first
    const allContainers = this.radioButtonsWrapElem.querySelectorAll('.custom_select__container');
    allContainers.forEach((container) => {
      container.style.opacity = '';
      container.style.pointerEvents = '';
      container.dataset.disabled = '';
      const input = container.querySelector('input[type="radio"]');
      if (input) input.disabled = false;
    });

    // Apply each matching rule
    for (const rule of this.dependencyRules) {
      const matchingValue = selectedValues[rule.if_option];
      if (!matchingValue) continue;

      const ruleMatches = rule.if_values.some((v) => matchingValue.includes(v));
      if (!ruleMatches) continue;

      for (const [targetOption, targetValues] of Object.entries(rule.then_disable)) {
        const groupId = this.productId + '_' + this.lowerNoSpaces(targetOption) + '_selector_group';
        const group = document.getElementById(groupId);
        if (!group) continue;

        group.querySelectorAll('.custom_select__container').forEach((container) => {
          const input = container.querySelector('input[type="radio"]');
          if (!input) return;

          const shouldDisable = targetValues.some((v) => input.value.includes(v));
          if (shouldDisable) {
            container.style.opacity = '0.6';
            container.style.pointerEvents = 'none';
            container.dataset.disabled = 'true';
            input.disabled = true;

            if (input.checked) {
              input.checked = false;
              const valueText = this.radioButtonsWrapElem.querySelector(
                '.' + this.selectorGroupValueTextClass + this.lowerNoSpaces(targetOption)
              );
              if (valueText) {
                valueText.innerText = '';
                valueText.classList.remove('selector_group__value_text_filled');
              }
            }
          }
        });

        // Auto-select the first enabled option in this group if nothing is selected
        const checkedInput = group.querySelector('input[type="radio"]:checked');
        if (!checkedInput) {
          const firstEnabled = group.querySelector('.custom_select__container:not([data-disabled="true"]) input[type="radio"]');
          if (firstEnabled) {
            requestAnimationFrame(() => firstEnabled.click());
          }
        }
      }
    }
  }

  radioListener(evt) {
    if (this.isLoading) {
      evt.preventDefault();
      return;
    }

    this.applyDependencyRules(evt.target.name, evt.target.value);
    this.updateBeltDrivenMotorUi();
    this.showLoading();

    if (evt.target.name !== "Color") {
      const ralInputBox = document.querySelector(".edition-box");
      if (ralInputBox) {
        setTimeout(() => {
          const duplicateRalInputBox = ralInputBox.cloneNode(true);
          const closestSelectorGroup =
            evt.target.closest(".product__information-component-options") ||
            evt.target.closest(".product__info-wrapper");
          const colorSelectorGroup = closestSelectorGroup.querySelector(
            '.selector_group[data-name="Color"]'
          );

          const h3Selector = colorSelectorGroup.querySelector("h3");

          h3Selector.parentNode.insertBefore(duplicateRalInputBox, h3Selector);
        }, 100);
      }
    }

    if (evt.target.value.includes("[Spe]")) {
      const closestSelectorGroup = evt.target.closest(".selector_group");
      const box = document.createElement("div");
      box.classList.add("edition-box");

      setTimeout(() => {
        const pEle = document.createElement("p");
        pEle.style.margin = "0";
        pEle.innerText = "RAL";

        const inputEle = document.createElement("input");
        inputEle.classList.add("edition-spe-input");
        inputEle.type = "text";
        inputEle.required = true;
        inputEle.placeholder = "- - - -";
        inputEle.name = "properties[RAL]";

        inputEle.addEventListener("input", (event) => {
          if (event.target.value.length > 4) {
            event.target.value = event.target.value.slice(0, 4);
          }
        });

        const h3Selector = closestSelectorGroup.querySelector("h3");
        h3Selector.parentNode.insertBefore(box, h3Selector);
        box.appendChild(pEle);
        box.appendChild(inputEle);
      }, 1000);
    } else {
      const editionBox = document.querySelector(".edition-box");
      if (editionBox) {
        editionBox.remove();
      }
    }

    let radioOptionValueText = this.radioButtonsWrapElem.querySelector(
      "." +
        this.selectorGroupValueTextClass +
        this.lowerNoSpaces(evt.target.name)
    );
    radioOptionValueText.innerText = evt.target.dataset.optionTitleText;
    radioOptionValueText.classList.add("selector_group__value_text_filled");
    document.getElementById(this.selectorElementId + "__alert").style.display = this.radioButtonsWrapElem.checkValidity() ? "none" : "block";
    if (this.radioButtonsWrapElem.checkValidity()) {
      const formData = new FormData(this.radioButtonsWrapElem);
      let parsedFormData = {};
      for (var pair of formData.entries()) {
        parsedFormData[pair[0]] = pair[1];
      }
      this.getMatchedProduct(parsedFormData);
    } else {
      this.hideLoading();
    }
  }

  showLoading() {
    this.isLoading = true;
    const overlay = document.getElementById("loading-overlay");
    if (overlay) {
      overlay.classList.add("block");
    }

    // Only disable the form during loading
    if (this.radioButtonsWrapElem) {
      this.radioButtonsWrapElem.style.pointerEvents = "none";
      this.radioButtonsWrapElem.style.opacity = "0.7";
    }
  }

  hideLoading() {
    this.isLoading = false;
    const overlay = document.getElementById("loading-overlay");
    if (overlay) {
      overlay.classList.remove("block");
    }

    // Re-enable the form
    if (this.radioButtonsWrapElem) {
      this.radioButtonsWrapElem.style.pointerEvents = "auto";
      this.radioButtonsWrapElem.style.opacity = "1";
    }
  }

  getMatchedProduct(formData) {
    const requiredOptionCount = Object.keys(formData).length;
    for (let childProduct in this.childProductJSON) {
      let foundOptionCount = 0;
      for (let childProductOption in this.childProductJSON[childProduct]) {
        if (
          formData[childProductOption] ==
          this.childProductJSON[childProduct][childProductOption]
        ) {
          foundOptionCount++;
          if (foundOptionCount == requiredOptionCount) {
            this.getProductContents(
              this.childProductJSON[childProduct]["handle"]
            );
            // console.log("childProductJSON", this.childProductJSON[childProduct]);
            return this.childProductJSON[childProduct];
          }
        }
      }
    }
    this.hideLoading();
  }

  getProductContents(handle) {
    this._contentCache = this._contentCache || {};

    const applyContent = (doc) => {
      let contentSelectors = [
        ".product media-gallery",
        "product-modal",
        ".product__info-wrapper product-form",
        ".product .price",
        ".product .product__additional_informations",
        ".product__media-submedia-wrapper",
        ".product_info_ed",
        ".product_info_ed_mobile",
      ];

      if (this.elementUpdateContentMap) {
        contentSelectors = this.elementUpdateContentMap;
      }

      for (let selector of contentSelectors) {
        this.replaceContent(doc, selector);
      }

      let elementsToShow = document.querySelectorAll(
        ".price, .product__tax, .product-form__input, .product-form"
      );
      elementsToShow.forEach((elem) => {
        elem.style.display = "block";
      });

      this.hideLoading();
    };

    if (this._contentCache[handle]) {
      applyContent(this._contentCache[handle]);
      return;
    }

    let productUrl = this.productHandleTemplate.replace("{handle}", handle);
    if (this.templateSuffix) {
      // note: we dont use template suffix layout none because client doesn't want to edit 2 templates each time changing section settings
      productUrl += "?view=" + this.templateSuffix;
    }

    fetch(productUrl)
      .then((resp) => {
        if (!resp.ok) throw new Error("Network response was not ok");
        return resp.text();
      })
      .then((data) => {
        const parser = new DOMParser();
        let doc = parser.parseFromString(data, "text/html");
        this._contentCache[handle] = doc;
        applyContent(doc);
      })
      .catch((error) => {
        console.error("Error fetching product contents:", error);
        this.hideLoading();
      });
  }

  replaceContent(remoteDoc, selector) {
    let remoteElement = remoteDoc.querySelector(
      typeof selector === "object" ? selector["remote_element"] : selector
    );
    let localElement = document.querySelector(
      typeof selector === "object" ? selector["local_element"] : selector
    );

    if (remoteElement && localElement) {
      localElement.outerHTML = remoteElement.outerHTML;
    }
  }

  lowerNoSpaces(text) {
    return text.toLowerCase().replaceAll(" ", "_");
  }
}
